import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsDownUp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.875 12.375L5.625 14.625M5.625 14.625L3.375 12.375M5.625 14.625V3.375M10.125 5.625L12.375 3.375M12.375 3.375L14.625 5.625M12.375 3.375V14.625", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowsDownUp);
export { ForwardRef as ReactComponent };
